<template>
  <h1>this.is.config-test.page</h1>
</template>

<script>
export default {

}
</script>

<style>

</style>